import configs from '@aqx-core/common/configs';

import { configService } from './service';

class ConfigViewController {
  public getCurrentApiDomain = () => configService.context.currentApiDomain;

  public getCurrentStaticDomain = () => configService.context.currentStaticDomain;

  public switchToFallbackDomain = () => {
    const fallbackApiDomain = configs.apiDomainFallback;
    const fallbackStaticDomain = configs.staticDomainFallback;

    if (fallbackApiDomain && configService.context.currentApiDomain !== fallbackApiDomain) {
      configService.context.currentApiDomain = fallbackApiDomain;
    }

    if (fallbackStaticDomain && configService.context.currentStaticDomain !== fallbackStaticDomain) {
      configService.context.currentStaticDomain = fallbackStaticDomain;
    }
  };

  public resetToDefaultDomain = () => {
    configService.context.currentApiDomain = configs.apiDomain || '';
    configService.context.currentStaticDomain = configs.staticDomain || '';
  };

  /** temporary display, remove after tested */
  public setApiResponseError = (error: string) => {
    configService.setApiResponseError(error);
  };
}

export const configViewController = new ConfigViewController();
